<template>
  <div class="d-flex _backoffice">

    <v-navigation-drawer app permanent :color="scdColor" dark clipped>
      <div style="padding: 20px 16px;" class="d-flex align-center">
        <v-btn to="/" fab depressed small color="white" class="mr-4">
          <v-icon :color="scdColor">mdi-arrow-left-thick</v-icon>
        </v-btn>
        <router-link to="/backoffice" tag="div" class="_backoffice_logo _backoffice_logo_small" style="cursor:pointer;">BACKOFFICE</router-link>
        <!-- <div class="_backoffice_logo _backoffice_logo_small">
          BACKOFFICE
        </div> -->
      </div>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item link to="/backoffice/notifiche">
          <v-list-item-icon>
            <v-icon>mdi-bell</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Notifiche</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <div class="py-10 px-8" style="height:100vh; width:100%">
			<!-- <transition :name="transitionName"> -->
      	<router-view></router-view>
			<!-- </transition> -->
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedItem: null,
			transitionName: 'slide-left',
    }
  },
	beforeRouteUpdate (to, from, next) {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    next()
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');

// Vue Transitions Classes
// .slide-right-leave-active,
// .slide-left-enter-active {
//   transition: 1s;
// }
// .slide-right-enter {
//   transform: translate(100%, 0);
// }
// .slide-left-leave-to {
//   transform: translate(-100%, 0);
// }

// ------------------------

._backoffice {
  font-family: 'Montserrat', sans-serif !important;
}
._backoffice_logo {
  font-family: 'Press Start 2P', sans-serif !important;
}
._backoffice_logo_small {
  margin-top: 2px;
  color: white;
  font-size: 16px;
}
._backoffice_logo_big {
  color: #e6901c;
  font-size: 31px;
  align-self: end;
  margin-right: 14px;
}
</style>